<template>
  <div class="fullscreen_bg" :style="{ backgroundImage: 'url(dist/img/' + fondo + ')' }">
    <title>KUBBER EDS | v.{{ GLOBAL.VERSION }}</title>

    <div class="form-signin" :class="{ shake: animateShake }">
      <div :class="[bandera, 'form-bandera']"></div>

      <div class="form-border">
        <div class="form-signin-heading">
          <img class="logo" src="dist/img/kubber-logo-transparente.png?v=1" width="250" alt="Kubber" />
          <div class="form-label">INICIAR SESSIÓN {{ GLOBAL.COUNTRY }}</div>
        </div>

        <form @submit.prevent="login" novalidate>
          <input v-model="usuario" type="text" class="form-control" placeholder="USUARIO" autocomplete="off" autofocus
            style="text-transform: uppercase" @blur="usuario = (usuario || '').toUpperCase()" :disabled="loading" />

          <input v-model="clave" type="password" class="form-control" placeholder="CONTRASEÑA" autocomplete="off"
            :disabled="loading" />

          <div class="form-text-center">
            <button class="btn bg-orange form-text-button btn-login" type="submit" :disabled="loading">
              <span v-if="!loading">INGRESAR</span>
              <span v-else class="btn-loading">
                <span class="spinner" aria-hidden="true"></span>
                Iniciando…
              </span>
            </button>

            <!-- Mensaje animado -->
            <transition name="fade-slide">
              <div v-if="error && mensaje" class="alert-msg" role="alert" aria-live="polite">
                {{ mensaje }}
              </div>
            </transition>

            <div class="version-text">
              {{ GLOBAL.COUNTRY }} | Versión {{ GLOBAL.VERSION }}
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import axios from "axios";
import GLOBAL from "../Global.js";
import md5 from "md5";

export default {
  name: "HomeView",
  data() {
    return {
      GLOBAL,
      usuario: "",
      clave: "",
      error: false,
      mensaje: "",
      loading: false,
      animateShake: false,

      fondo:
        GLOBAL.COUNTRY == "CO" ? "kubber-fondo-co.jpg" : "kubber-fondo-mx.jpg",
      bandera: GLOBAL.COUNTRY == "CO" ? "form-co" : "form-mx",
    };
  },
  methods: {
    login() {
      if (this.loading) return;

      this.usuario = (this.usuario || "").toUpperCase();

      if (!this.usuario.trim() || !this.clave) {
        this.setError("Ingresa usuario y contraseña.", true);
        return;
      }

      this.getPersona();
    },

    triggerShake() {
      this.animateShake = false;
      // Reinicia la animación (forzar reflow)
      // eslint-disable-next-line no-unused-expressions
      void this.$el && this.$el.offsetWidth;
      this.animateShake = true;
      window.setTimeout(() => (this.animateShake = false), 450);
    },

    setError(msg, withShake = true) {
      this.error = true;
      this.mensaje = msg;
      if (withShake) this.triggerShake();
    },

    clearError() {
      this.error = false;
      this.mensaje = "";
    },

    async getPersona() {
      const url = GLOBAL.BASE_URL + GLOBAL.API_GET_LOGIN;

      this.usuario = (this.usuario || "").toUpperCase();
      this.clearError();
      this.loading = true;

      const request = {
        usuario: btoa(this.usuario),
        clave: btoa(md5(this.clave)),
      };

      try {
        const response = await axios.post(url, request, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "Basic " + GLOBAL.BASIC_API,
          },
          timeout: 15000,
        });

        sessionStorage.removeItem(GLOBAL.SESSION_KEY);

        const json = response;
        this.person = json.data.usuario;

        // Decodificaciones
        this.person.identificacion = atob(this.person.identificacion);

        let empresas = "";
        for (const i in this.person.empresas_nodo) {
          empresas += atob(this.person.empresas_nodo[i].empesa_id) + ",";
        }
        empresas = empresas.substring(0, empresas.length - 1);

        this.person.empresas = empresas;
        this.person.token = btoa(this.usuario + ":" + this.clave);

        GLOBAL.PERFIL = this.person.perfil_id;

        const url1 = GLOBAL.API_GET_LISTA_ATRIBUTOS_EMPRESA;

        if (GLOBAL.COUNTRY === "MX") {
          try {
            const resp2 = await axios.get(url1.trim(), {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: "Basic " + this.person.token,
                Environment: this.person.empresas,
              },
              timeout: 15000,
            });

            try {
              this.person.parametros = {};
              this.person.parametros.permiso_cre =
                resp2.data.parametros.permiso_cre;
              this.person.parametros.codigo_postal_expedicion =
                resp2.data.parametros.codigo_postal_expedicion;
              this.person.parametros.zona_horaria =
                resp2.data.parametros.zona_horaria;
              this.person.parametros.factor_m3 =
                resp2.data.parametros.factor_m3;
            } catch (e) {
              // Ignorar si vienen incompletos
            }
          } catch (e) {
            // No bloquea el login; solo informa
            this.setError(
              "No se pudieron cargar parámetros de empresa. Se continuará con valores por defecto.",
              false
            );
          } finally {
            sessionStorage.setItem(
              GLOBAL.SESSION_KEY,
              JSON.stringify(this.person)
            );
            router.push({
              name: "home",
              params: { data: JSON.stringify(this.person) },
            });
          }
        } else {
          sessionStorage.setItem(GLOBAL.SESSION_KEY, JSON.stringify(this.person));
          router.push({
            name: "home",
            params: { data: JSON.stringify(this.person) },
          });
        }
      } catch (error) {
        const status = error?.response?.status;

        if (status === 401) {
          this.setError("Usuario o contraseña inválidos.", true);
        } else if (status === 403) {
          this.setError("Acceso denegado. Verifica permisos del usuario.", true);
        } else if (status >= 500 && status <= 599) {
          this.setError("Servicio no disponible. Intente más tarde.", true);
        } else if (status) {
          this.setError(`No se pudo iniciar sesión (HTTP ${status}).`, true);
        } else if (error?.code === "ECONNABORTED") {
          this.setError(
            "Tiempo de espera agotado. Verifica tu conexión e intenta nuevamente.",
            true
          );
        } else {
          this.setError(
            "No fue posible conectar con el servicio. Verifica tu conexión e intenta nuevamente.",
            true
          );
        }

        // (Opcional) log
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ---- Base ---- */
.btn {
  outline: 0;
  border: none;
}

.btn:focus {
  outline: 0;
  -webkit-outline: 0;
  -moz-outline: 0;
}

.form-text-center {
  text-align: center;
}

.form-text-button {
  font-family: "Oswald", sans-serif;
  color: white !important;
}

.form-label {
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  color: #ea592c;
}

.fullscreen_bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-size: cover;
  background-position: top right;
  background-repeat: repeat;
}

/* ---- Card ---- */
.form-border {
  background-color: rgb(244, 244, 244);
  padding: 10px 20px 20px;
  border-left: 1px solid rgb(138, 138, 138);
  border-right: 1px solid rgb(138, 138, 138);
  border-bottom: 1px solid rgb(138, 138, 138);

  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.form-signin {
  border-radius: 8px;
  border: 1px solid #ccc;
  max-width: 320px;
  padding: 10px;
  position: relative;
  margin: 0px auto;
  top: 20%;
  width: 320px;
  box-sizing: border-box;

  background: rgb(255, 255, 255);
  background: linear-gradient(0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(209, 209, 209, 0.1) 100%);

  /* animación discreta de entrada */
  animation: cardIn 320ms ease-out;
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0px);
  }
}

.form-bandera {
  border-top: 1px solid rgb(99, 99, 99);
  border-right: 1px solid rgb(99, 99, 99);
  border-left: 1px solid rgb(99, 99, 99);
  height: 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.form-mx {
  background: linear-gradient(90deg,
      rgba(35, 125, 34, 1) 0%,
      rgba(23, 255, 0, 1) 30%,
      rgba(255, 255, 255, 1) 30%,
      rgba(255, 255, 255, 1) 72%,
      rgba(255, 0, 0, 1) 72%);
}

.form-co {
  background: linear-gradient(90deg,
      rgba(255, 207, 0, 1) 0%,
      rgba(251, 255, 0, 1) 39%,
      rgba(0, 11, 255, 1) 39%,
      rgba(3, 44, 133, 1) 72%,
      rgba(255, 0, 0, 1) 72%);
}

.form-signin .form-signin-heading,
.form-signin {
  margin-bottom: 10px;
}

.form-signin .form-control {
  position: relative;
  font-size: 16px;
  height: auto;
  padding: 10px;
  box-sizing: border-box;
  transition: box-shadow 180ms ease, transform 180ms ease;
}

.form-signin .form-control:focus {
  z-index: 2;
  box-shadow: 0 0 0 3px rgba(234, 89, 44, 0.15);
  transform: translateY(-1px);
}

.form-signin input[type="text"] {
  margin-bottom: -1px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: none;
  border-left-style: solid;
  border-color: #000;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top-style: none;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-color: rgb(0, 0, 0);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.form-signin-heading {
  color: rgb(84, 84, 84);
  text-align: center;
  font-size: 30px;
}

.logo {
  display: inline-block;
  transform-origin: center;
  animation: logoPop 380ms ease-out 80ms;
}

@keyframes logoPop {
  from {
    opacity: 0;
    transform: scale(0.98);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* ---- Button ---- */
.btn-login {
  min-width: 160px;
  border-radius: 6px;
  transition: transform 120ms ease, filter 120ms ease, opacity 120ms ease;
}

.btn-login:hover:enabled {
  transform: translateY(-1px);
  filter: brightness(1.02);
}

.btn-login:active:enabled {
  transform: translateY(0px);
  filter: brightness(0.98);
}

.btn-login:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

/* Loading inline */
.btn-loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: rgba(255, 255, 255, 1);
  animation: spin 750ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ---- Error message (transition) ---- */
.alert-msg {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid rgba(176, 0, 32, 0.25);
  background: rgba(176, 0, 32, 0.06);
  color: #b00020;
  font-size: 12px;
  text-align: center;
}

/* Vue transition hooks */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0px);
}

/* ---- Shake on error ---- */
.shake {
  animation: shake 420ms ease-in-out;
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  15% {
    transform: translateX(-6px);
  }

  30% {
    transform: translateX(6px);
  }

  45% {
    transform: translateX(-5px);
  }

  60% {
    transform: translateX(5px);
  }

  75% {
    transform: translateX(-3px);
  }
}

/* ---- Footer text ---- */
.version-text {
  margin-top: 8px;
  font-size: 10px;
  color: rgb(156, 154, 154);
}
</style>
